// Masks input to US phone format: (###) ###-####
export function formatUSPhone(value) {
  const d = (value || "").replace(/\D/g, "").slice(0, 10);
  const len = d.length;
  if (len === 0) return "";
  if (len < 4) return `(${d}`;
  if (len < 7) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}

export function isValidUSPhone(value) {
  return (value || "").replace(/\D/g, "").length === 10;
}
